import { VendorFileArchiveContext } from 'contexts/VendorFileArchiveContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import React, { useContext, useMemo } from 'react';
import {
	Content,
	Description,
	Section,
	Sidebar,
	TabsWrapper,
	Title,
	Wrapper,
} from './VendorCleanup.styles';
import VendorData from './VendorData/VendorData';
import { UploadVendorStateContext } from 'contexts/UploadVendorStateContext';
import { VENDOR_NORMALIZATION_SPEND_TYPE } from 'Data/utils';
import SidebarNavLink from 'Data/components/SidebarNavLink';
import { Route, Redirect, Switch } from 'react-router-dom';
import {
	NormalizationProvider,
	useNormalizationContext,
} from 'contexts/NormalizationContext/NormalizationProvider';
import { SPEND_TYPE } from '../constants';
import { UploadVendorStateContextProvider } from 'contexts/UploadVendorStateContext/UploadVendorStateContextProvider';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';

const VendorCleanup = ({ permissions, status }) => {
	const { isLoading, existingRoute, currentRoute } = useNormalizationContext();
	const { isShowRedirectionMessage } = useContext(GenerateSpendCubeContext);

	const showRoute = useMemo(
		() =>
			!isLoading &&
			VENDOR_NORMALIZATION_SPEND_TYPE.find(({ required, name }) => {
				return permissions.includes(required) && name === existingRoute;
			}),
		[isLoading, existingRoute, permissions]
	);

	return (
		<Wrapper>
			<Sidebar>
				<Section>
					<Title>Data upload</Title>
					<Description>
						<p>Data upload process:</p>
						<p>1. Upload file into the system</p>
						<p>2. Configure set up</p>
						<p>3. Cleanup vendor names</p>
					</Description>
				</Section>
				<TabsWrapper>
					{VENDOR_NORMALIZATION_SPEND_TYPE.map(({ label, path, required }) => {
						if (required && !permissions.includes(required)) {
							return null;
						}

						return (
							<SidebarNavLink
								key={path}
								to={path}
								iconName="cloud_upload"
								disabled={status.state !== 1 || isShowRedirectionMessage}
							>
								{label}
							</SidebarNavLink>
						);
					})}
				</TabsWrapper>
			</Sidebar>
			<Content>
				<Switch>
					{VENDOR_NORMALIZATION_SPEND_TYPE.map(({ path, required }) => {
						if (!permissions.includes(required)) {
							return null;
						}
						return (
							<Route
								key={path}
								path={path}
								render={() => (
									<VendorData
										status={status}
										isDirect={currentRoute === SPEND_TYPE.DIRECT}
									/>
								)}
							/>
						);
					})}
					{showRoute && <Redirect to={showRoute.path} />}
				</Switch>
			</Content>
		</Wrapper>
	);
};

export default props => (
	<NormalizationProvider>
		<UploadVendorStateContextProvider>
			<VendorFileArchiveContext.Consumer>
				{({ fileArchive }) => (
					<UploadVendorStateContext.Consumer>
						{({ vendorStatus }) => (
							<PermissionsContext.Consumer>
								{({ permissions }) => (
									<VendorCleanup
										{...props}
										permissions={permissions || []}
										status={vendorStatus}
										fileArchive={fileArchive}
									/>
								)}
							</PermissionsContext.Consumer>
						)}
					</UploadVendorStateContext.Consumer>
				)}
			</VendorFileArchiveContext.Consumer>
		</UploadVendorStateContextProvider>
	</NormalizationProvider>
);
